/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {Кто получает еженедельные обновления по проекту?} goal {Кто получает еженедельные обновления по целям?} other {Кто получает еженедельные обновления?}}',
  'share-modal.add-as-follower-checkbox-label': 'Добавить в качестве подписчика',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {Подписчики получают еженедельные обновления по проектам в своих дайджестах} goal {Подписчики получают еженедельные обновления по целям в своих дайджестах} other {Подписчики получают еженедельные обновления в своих дайджестах}}',
  'share-modal.all-tab-label': 'Все',
  'share-modal.contributors-tab-label': 'Участники',
  'share-modal.followers-tab-label': 'Подписчики',
  'share-modal.followers-title': 'Подписчики',
  'share-modal.footer.access-level-disclaimer':
    '{entity, select, project {Все пользователи, имеющие доступ к рабочей области, смогут видеть этот проект.} goal {Все пользователи, имеющие доступ к рабочей области, смогут видеть эту цель.} other {Все пользователи, имеющие доступ к рабочей области, смогут видеть}}',
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {Закрытый проект} goal {Закрытая цель} other {}}',
  'share-modal.footer.copy-link-button': 'Копировать ссылку',
  'share-modal.footer.copy-link-button.copied-tooltip': 'Скопировано',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {Копировать ссылку на проект} goal {Копировать ссылку на цель} other {Копировать ссылку на }}',
  'share-modal.modal.user-picker.add-more-placeholder': 'Добавить еще пользователей',
  'share-modal.share-button': 'Поделиться',
  'share-modal.share-title': 'Поделиться',
  'share-modal.user-item.can-edit-label': 'Разрешено редактирование',
  'share-modal.user-picker.placeholder': 'Поиск и приглашение пользователей',
  'shareModal.followers-empty-state.default-title': 'Нет основных заинтересованных лиц?',
  'shareModal.followers-empty-state.goal-cta':
    'Добавьте их в качестве подписчиков либо подключите канал Slack или MS Teams, чтобы они получали последние обновления по вашей цели в ежемесячном дайджесте',
  'shareModal.followers-empty-state.project-cta':
    'Добавьте основные команды и заинтересованных лиц в качестве подписчиков, чтобы держать их в курсе событий. Подключите канал, чтобы делиться обновлениями прямо в чате.',
  'shareModal.followers-empty-state.project-title': 'Добавьте подписчиков, чтобы расширить свою аудиторию',
};
